<app-tick-card class="widget" [isCollapsable]="false" [isHeaderDisplayed]="false">
  <div class="orders-list-filters row">
    <div class="orders-list-filter-fields col-md-12 col-lg-9">
      <app-table-filter
        [filters]="filters"
        (filterChange)="setFilters($event)"
        [(expanded)]="isTogglersExpanded"
        [isDefaultFormat]="true"
      ></app-table-filter>
    </div>
    <div class="orders-list-type-results col-md-12 col-lg-3">
      @if(isToggleDisplayed) {
      <div class="orders-list-type-togglers">
        <mat-slide-toggle
          #SeatsToggle
          data-cy="seats-toggle"
          class="me-3 mb-1"
          [ngModel]="isSessionsDisplayed()"
          (ngModelChange)="toggleSessionType()"
          ><mat-icon class="material-icons-outlined me-1">confirmation_number</mat-icon>
          {{ 'orders.seats' | translate }}
        </mat-slide-toggle>
        <mat-slide-toggle
          #productToggle
          data-cy="products-toggle"
          [ngModel]="isProductsDisplayed()"
          (ngModelChange)="toggleProductType()"
          ><mat-icon class="material-icons-outlined me-1">shopping_cart</mat-icon>
          {{ 'orders.products' | translate }}
        </mat-slide-toggle>
      </div>
      } @if(resultInfo()) { @let result=resultInfo();
      <div class="orders-list-result-values">
        <div class="orders-list-order-count pe-2">
          <span class="highlighted">{{ result?.ordersCount | number }}</span>
          {{ 'orders.ordersShort' | translate }}
        </div>
        <div class="orders-list-places-count px-2">
          <span class="highlighted">{{ result?.seatCount | number }}</span>
          {{ 'orders.articlesShort' | translate }}:
          <span class="highlighted">{{
            result?.totalAmount | currency : 'EUR' : 'symbol' : '0.2-2' : 'fr'
          }}</span>
        </div>
        <button mat-button data-cy="orders-expand-icon" (click)="showOrHideToggles()">
          <mat-icon
            [ngbTooltip]="(isToggleDisplayed ? 'shared.tooltip.close' : 'shared.tooltip.open') | translate"
          >
            {{ isToggleDisplayed ? 'expand_less' : 'expand_more' }}
          </mat-icon>
        </button>
      </div>
      }
    </div>
  </div>
</app-tick-card>
